import { ReactComponent as SvgStarFull } from 'public/assets/icons/star-sharp.svg';
import Link from 'next/link';
import { Routes } from 'routes';
import {
  IRatingItem, IResortPathInfo, IResortReviews, IStarRating,
} from 'api/resort/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { SectionHeader } from '../SectionHeader';

import styles from './styles.module.scss';

const getRating = (item: IRatingItem) => {
  const ratingFields = ['familyFriendly', 'terrainPark', 'overallOther', 'intermediate', 'expert', 'beginner', 'apresSki', 'allTerrain'];

  const totalRating = ratingFields.reduce((points, field) => (item[field as keyof IStarRating] ?? 0) + points, 0);

  return parseInt(`${totalRating / ratingFields.length}`, 10);
};

const getReview = (reviewsList:Array<IRatingItem>) => {
  let rating = 0;
  const review = reviewsList.reduce((prev, curr, index) => {
    if (index === 1) {
      rating = getRating(prev);
    }

    if ((curr.review.length > prev.review.length) || rating < 3) {
      const averageRating = getRating(curr);
      if (averageRating > 2) {
        rating = averageRating;
        return curr;
      }
    }

    return prev;
  });

  return { review, rating };
};

interface Props {
  pathInfo:IResortPathInfo;
  resortReviews:IResortReviews;
}

export const ReviewsSection = ({ pathInfo, resortReviews }:Props) => {
  const { review, rating } = getReview(resortReviews.reviewsList);
  const { t } = useOTSTranslation('common');

  return (
    <section id={styles.reviews}>
      <SectionHeader title={t('nav.tab.reviews')} />
      <div className="column">
        <div className={styles.row}>
          <div className="">
            <p>
              {review.firstName}
              {' '}
              {review.lastName}
            </p>
          </div>
          <div className={styles.row}>
            {[...Array(rating).keys()].map(() => <SvgStarFull fill="#008CFF" height={20} />)}
          </div>
        </div>
        <i>
          {review.translated?.review ?? review.review}
        </i>
        <div>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link href={Routes.resortTripPlanningReviews(pathInfo)}>
            {t('resort.reviews.allReviews')}
          </Link>
        </div>
      </div>
    </section>
  );
};
